import React from "react";
import ReactDOM from "react-dom";
import FranchisesInCountries from "./containers/FranchisesInCountries";
import {isEmpty} from "lodash";

export const initFranchisesInCountries = className => {
  let elements = document.querySelectorAll(`.${className}`);
  if (!isEmpty(elements)) {
    for (let element of elements) {
      ReactDOM.render(<FranchisesInCountries/>, element);
    }
  }
};
